export default __webpack_public_path__ + "static/favicon-144x144-a398e9f3bc6bf48d58f4e9cf32b840b5.png";